<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: {
        period: '',

    },
    data() {
        return {
            times: [],
            rx_bytes: [],
            tx_bytes: [],
            data: '',
            colors: [],
        }
    },
    methods: {
        getData() {
            // console.log(this.tf);

            this.gradient = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 450);
            this.gradient2 = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 450);

            this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
            this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
            this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

            this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
            this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
            this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

            let uri = `/api/dashboard?node=wan_traffic&period=${this.period}`;
            axios.get(uri, {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.data = response.data.data;
                    if (this.data) {
                        this.data.forEach(element => {
                            ;
                            this.times.push(element.time);
                            this.rx_bytes.push(element.rx);
                            this.tx_bytes.push(element.tx);

                        });
                        this.renderChart({

                            labels: this.times,
                            datasets: [{
                                label: 'Upload GB',
                                borderColor: "#FC2525",
                                pointBackgroundColor: "white",
                                borderWidth: 1,
                                pointBorderColor: "white",
                                backgroundColor: this.gradient,
                                data: this.rx_bytes
                            }, {
                                label: 'Download GB',
                                borderColor: "#05CBE1",
                                pointBackgroundColor: "white",
                                pointBorderColor: "white",
                                borderWidth: 1,
                                backgroundColor: this.gradient2,
                                data: this.tx_bytes
                            }]
                        }, {
                            responsive: true,
                            maintainAspectRatio: false,
                            title: {
                                display: true,
                                text: 'Traffic all Devices',
                                fontSize: 16,
                            },
                            scales: {
                                xAxes: [{
                                    type: 'time',
                                    distribution: 'linear',
                                    time: {
                                        displayFormats: {
                                            quarter: 'MMM YYYY'
                                        }
                                    },
                                    gridLines: {
                                        display: false,
                                        color: "black"
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "",
                                        fontColor: "#05CBE1"
                                    },
                                }],
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: "GB",
                                        fontColor: "#05CBE1"
                                    },
                                }]
                            },

                        })

                    } else {
                        console.log('NO DATA');
                    }
                }).catch(error => {

                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);

                })

        },

    },

    mounted() {
        this.getData();
    }
}
</script>
